import { ApiPaths } from "../apiPaths"
import api from "../http"

export const loadNews = async () => {
    const result = await api.get(ApiPaths.news)
    return result.data
}
